<script lang="ts" setup>
const { trackEvent } = useGAnalytics();
const appStateStore = useAppStateStore();

const linkToGame = (game: Merchant) => {
  /*if (game.id === "diamond-dreams" && game.status === "COMING_SOON")
    return `/diamond-dreams`;*/
  //Temporal override for diamond-dreams market route to go directly to store
  //Maybe modify this to player's market or upgrades as desired
  if (game.id === "diamond-dreams" && game.status === "ACTIVE")
    return `/store/diamond-dreams`;
  if (game.status === "COMING_SOON") return undefined;
  const activePages = appStateStore.getMerchantActivePages(game.id);
  if (activePages?.includes("market")) return `/market/${game.id}`;
  if (activePages?.includes("store")) return `/store/${game.id}`;
  if (activePages?.includes("craft")) return `/craft/${game.id}`;
  return `/market/${game.id}`;
};

const xlGridCols = computed(() => {
  if (appStateStore.merchants.length >= 4) return "xl:grid-cols-4";
  if (appStateStore.merchants.length >= 3) return "xl:grid-cols-3";
  if (appStateStore.merchants.length >= 2) return "xl:grid-cols-2";
  return "xl:grid-cols-1";
});
</script>

<template>
  <h2 class="text-4xl font-bold text-neutral-300 mt-12 text-center">
    {{ $t("main.home.browse") }}
  </h2>
  <ul
    v-if="appStateStore.merchants"
    role="list"
    class="mx-auto mt-12 grid auto-rows-[360px] grid-cols-1 place-content-center sm:grid-cols-2 gap-4"
    :class="xlGridCols">
    <template
      v-for="(game, index) in appStateStore.merchants"
      :id="game.id + '-home'"
      :key="$t(`main.merchant.${game.id}`)">
      <li
        v-if="index < 4"
        class="relative saturate-100 border border-primary-900 rounded-lg shadow-xs bg-neutral-800 rounded-b-lg"
        @click="trackEvent(`${game.id}_home_game_card`)">
        <NuxtLinkLocale
          :id="game.id + '-home'"
          :to="linkToGame(game)"
          class="h-full grid grid-rows-[202px_158px] grid-cols-1 gap-y-8 overflow-hidden"
          :class="{ 'pointer-none': game.status === 'COMING_SOON' }"
          :data-test="'link-nav-' + game.id">
          <div class="relative w-full h-full rounded-t-lg">
            <div class="w-full h-full rounded-t-lg overflow-hidden">
              <img
                class="rounded-t-lg w-full h-full object-cover transition-transform duration-500 ease-in-out transform"
                :class="
                  game.status === 'COMING_SOON' ? null : 'hover:scale-110'
                "
                :src="getGameThumbnail(game.id)"
                alt="game thumbnail" />
            </div>
            <div
              v-if="game.status === 'COMING_SOON'"
              class="bg-primary-500 px-3 py-1 text-neutral-200 text-xs font-semibold rounded-xl absolute top-4 right-4 z-10 w-fit">
              {{ $t("main.home.comingSoon") }}
            </div>
            <img
              class="absolute -bottom-6 left-4 w-16 rounded-lg max-w-[64px] max-h-[64px] z-20 overflow-hidden"
              :src="getGameIcon(game.id)"
              :alt="$t(`main.merchant.${game.id}`)" />
          </div>
          <div class="relative pl-4">
            <div
              class="max-w-full px-4 flex flex-col items-start overflow-hidden">
              <h3
                class="max-w-full text-2xl font-bold leading-8 tracking-tight text-neutral-200 truncate">
                {{ $t(`main.merchant.${game.id}`) }}
              </h3>
              <p
                class="max-w-full text-base font-light leading-7 text-neutral-300 truncate">
                {{ $t(`main.home.genre.${game.id}`) }}
              </p>
              <div class="w-full pt-3.5 flex gap-2.5">
                <template v-for="platform in game.platforms">
                  <BaseIcon :name="platform" class="w-6 h-6 text-neutral-200" />
                </template>
              </div>
            </div>
          </div>
        </NuxtLinkLocale>
      </li>
    </template>
  </ul>
</template>
